import { React, useEffect } from 'react'
import { Link } from 'react-router-dom'

const Library = () => {
    useEffect(() => {
        document.body.style.backgroundImage = 'url("/images/library.jpg")'; // Set background image for the library page
        return () => { document.body.style.backgroundImage = 'none'; }; // Clean up function to reset background image on unmount
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="bg-white bg-opacity-90 rounded-lg shadow-lg p-8 max-w-3xl w-full mx-4">
                <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">
                    Buddhist Library
                </h1>

                <p className="text-lg text-gray-600 text-center mb-8">
                    Explore our collection of sacred Buddhist texts and mantras
                </p>

                <div className="grid md:grid-cols-3 gap-6">
                    {/* Mantras Section */}
                    <Link
                        to="/library/mantras"
                        className="bg-gradient-to-br from-amber-100 to-orange-200 hover:from-amber-200 hover:to-orange-300
                                 rounded-lg p-6 text-center transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
                    >
                        <div className="flex justify-center mb-4">
                            <svg className="w-10 h-10 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                                    d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-gray-800 mb-2">Mantras</h2>
                        <p className="text-gray-600">
                            Sacred sounds and phrases for meditation and spiritual practice
                        </p>
                    </Link>

                    {/* Sutras Section */}
                    <Link
                        to="/library/sutras"
                        className="bg-gradient-to-br from-blue-100 to-purple-200 hover:from-blue-200 hover:to-purple-300
                                 rounded-lg p-6 text-center transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
                    >
                        <div className="flex justify-center mb-4">
                            <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-gray-800 mb-2">Sutras</h2>
                        <p className="text-gray-600">
                            Ancient Buddhist scriptures and teachings
                        </p>
                    </Link>

                    {/* Dharma Works Section */}
                    <Link
                        to="/library/works"
                        className="bg-gradient-to-br from-teal-100 to-emerald-200 hover:from-teal-200 hover:to-emerald-300
                                 rounded-lg p-6 text-center transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
                    >
                        <div className="flex justify-center mb-4">
                            <svg className="w-10 h-10 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                                    d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-gray-800 mb-2">Dharma Works</h2>
                        <p className="text-gray-600">
                            PDFs, texts, and teachings from across Buddhist traditions
                        </p>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Library